var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[`${_vm.$appPrefix}-fixed-footer`]},[_c('ContentArea',{staticClass:"bg-white"},[_c('Container',[_c('Row',[_c('Col',[_c('div',{staticClass:"ver-pad-xs"},[_vm._t("default")],2)])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }